import axios from 'axios';

const apiURL = 'https://api.caralz.app/gastos';
//const apiURL = 'http://localhost:3000';
let token = localStorage.getItem('accessToken');

export const logOut = async () => {
  window.location.href = `${apiURL}/auth/logout`;
  localStorage.removeItem('accessToken');
};

export const logIn = async () => {
  window.location.href = `${apiURL}/auth/signin`;
};

export const updateGCS1 = (expenseData) => {return axios.post(`${apiURL}/table/updategcs1`, expenseData)};
export const sendPhoto = (nombrecarpeta, dataURL) => 
  {return axios.post(`${apiURL}/upload-photo`, { image: dataURL, nombrecarpeta: nombrecarpeta }); };
export const updateGCS2 = (expenseData) => {return axios.post(`${apiURL}/table/updategcs2`, expenseData)};
export const updateGCS3 = (expenseData) => {return axios.post(`${apiURL}/table/updategcs3`, expenseData)};
export const insertarDetalleGCS = (expenseData) => {return axios.post(`${apiURL}/table/insert`, expenseData)};
export const selectProveedores = (query) => {return axios.get(`${apiURL}/table/suppliers`, {params : {query}});};
export const selectDepartamentos = (query) => {return axios.get(`${apiURL}/table/cities`, {params : {query}});};
export const selectConceptos = (query) => {return axios.get(`${apiURL}/table/concepts`, {params : {query}});};
export const selectClientCodes = (query) => {return axios.get(`${apiURL}/table/clientCodes`, {params : {query}});};
export const selectMaestroGastos = async (query) => {
  token = localStorage.getItem('accessToken');
  return axios.get(`${apiURL}/table/masterSpent`, {
    headers: {'authorization': `Bearer ${token}`}, 
    params : {query}
  })
  .then(response => response)
  .catch(error => {
    console.error('Error en la solicitud:', error.message);
  })
  };
export const selectMaestroGastosByUser = async (query) => {
  token = localStorage.getItem('accessToken');
  return axios.get(`${apiURL}/table/usersSpents`, {
    headers: {'authorization': `Bearer ${token}`}, 
    params : {query}
  })
  .then(response => response)
  .catch(error => {
    console.error('Error en la solicitud:', error.message);
  })
  };

  export const tokenValidation = async () => {
    token = localStorage.getItem('accessToken');
    return axios.get(`${apiURL}/auth/getUserInfo`, {headers: {'authorization': `Bearer ${token}`}})
    .then(response => {return response;})
  .catch(error => {
    alert("Sesión expirada, recargando pagina...")
    console.error('Error en la solicitud:', error.message);
  })};
  
export const selectTiposGastos = (query) => {return axios.get(`${apiURL}/table/spentTypes`, {params : {query}});};
export const selectMonedas = (query) => {return axios.get(`${apiURL}/table/currency`, {params : {query}});};
export const selectMediosPago = (query) => {return axios.get(`${apiURL}/table/meansOfPayment`, {params : {query}});};
export const selectMediosTransporte = (query) => {return axios.get(`${apiURL}/table/meansOfTransport`, {params : {query}});};

// Crear carpeta del gasto en OneDrive e insertar datos en bd
export const OneDr = (expenseData) => {
  return axios.post(`${apiURL}/onedrive/mainandspentfolder`,
  {headers: {'authorization': `Bearer ${token}`},params : {expenseData}});};

  // Subir archivo adjunto a carpeta
export const uploadToOneDr = (nombreArchivo, formData, nombreGasto) => 
  {return axios.post(`${apiURL}/onedrive/uploadFile`,formData,{headers: {'authorization': `Bearer ${token}`}, params : {nombreArchivo, nombreGasto}}
    );
  };

export const updateProviders = (formData, table) => // Actualizacion en bloque de proveedores
  {return axios.post(
    `${apiURL}/table/providers`,
    formData,
    {headers: {'authorization': `Bearer ${token}`}, params: {Table: table}}
    );
  };
/*
  export const uploadToOneDr = (nombreArchivo, formData, nombreGasto) => 
    {return axios.post(`${apiURL}/onedrive/uploadFile`,formData,{headers: {'authorization': `Bearer ${token}`},'Content-Type': 'multipart/form-data',params : {nombreArchivo, nombreGasto}}
      );
    };
*/

export const selectUsersWithSpents = (query) => {return axios.get(`${apiURL}/table/userPermissions`, {params : {query}});};

export const selectPermisosComponentes = (query) => {return axios.get(`${apiURL}/table/componentPermissions`, {params : {query}});};

export const selectIdByEmail = (query) => {
  return axios.get(`${apiURL}/table/idByEmail`, {params: {query}})
}

// Obtener archivos
export const selectObtener_archivos = (query) => {
  return axios.post(`${apiURL}/function/querySpent1`,query, {headers: {'authorization': `Bearer ${token}`}});
};
// Obtener archivos
export const selectObtener_SpentsToAuthorize = (query) => {
  return axios.post(`${apiURL}/function/querySpentAuthorize`,query, {headers: {'authorization': `Bearer ${token}`}});
};

export const selectObtener_SpentsToAccount = (query) => {
  return axios.post(`${apiURL}/function/querySpentAccount`,query, {headers: {'authorization': `Bearer ${token}`}});
};

// Autorizar gastos
export const selectSpentDetail = (query) => {
  return axios.get(`${apiURL}/table/spentDetail`, {params: query});
};

export const selectSpentDetailEdit = (query) => {
  return axios.get(`${apiURL}/table/spentDetail/query`, {params: query});
};


export const authorizeSpents = (query, tableType) => {
  return axios.post(`${apiURL}/table/authorize`, {parameters: {query}, table: tableType});
};

export const accountSpents = (query, tableType) => {
  return axios.post(`${apiURL}/table/account/modify`, {parameters: {query}, table: tableType});
};

export const editSpents = (query, tableType) => {
  return axios.post(`${apiURL}/table/edit/update`, {parameters: {query}, table: tableType});
};